import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import { DefectiveComponentReplacement } from '../../../types/defective-component-replacement';
import {
    updateMaterialSwapIn,
    updateMaterialSwapOut,
    updateRepairTime,
    updateSerialSwapIn,
    updateSerialSwapOut,
} from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateMaterialSwapInReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        xmlId: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldDefectiveComponentReplacement = state.participantCopies[state.selectedParticipantCopyId]
        .functionalElements[props.id] as DefectiveComponentReplacement;

    if (oldDefectiveComponentReplacement.swapInComponent.matNo === props.newValue) {
        return state;
    }

    const newDefectiveComponentReplacement: { [key: string]: Readonly<DefectiveComponentReplacement> } = {};
    newDefectiveComponentReplacement[props.id] = {
        ...oldDefectiveComponentReplacement,
        swapInComponent: {
            ...oldDefectiveComponentReplacement.swapInComponent,
            matNo: props.newValue,
        },
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDefectiveComponentReplacement,
    });
}

export function updateSerialSwapInReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        xmlId: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldDefectiveComponentReplacement = state.participantCopies[state.selectedParticipantCopyId]
        .functionalElements[props.id] as DefectiveComponentReplacement;

    if (oldDefectiveComponentReplacement.swapInComponent.serialNo === props.newValue) {
        return state;
    }

    const newDefectiveComponentReplacement: { [key: string]: Readonly<DefectiveComponentReplacement> } = {};
    newDefectiveComponentReplacement[props.id] = {
        ...oldDefectiveComponentReplacement,
        swapInComponent: {
            ...oldDefectiveComponentReplacement.swapInComponent,
            serialNo: props.newValue,
        },
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDefectiveComponentReplacement,
    });
}

export function updateMaterialSwapOutReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        xmlId: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldDefectiveComponentReplacement = state.participantCopies[state.selectedParticipantCopyId]
        .functionalElements[props.id] as DefectiveComponentReplacement;

    if (oldDefectiveComponentReplacement.swapOutComponent.matNo === props.newValue) {
        return state;
    }

    const newDefectiveComponentReplacement: { [key: string]: Readonly<DefectiveComponentReplacement> } = {};
    newDefectiveComponentReplacement[props.id] = {
        ...oldDefectiveComponentReplacement,
        swapOutComponent: {
            ...oldDefectiveComponentReplacement.swapOutComponent,
            matNo: props.newValue,
        },
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDefectiveComponentReplacement,
    });
}

export function updateSerialSwapOutReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        xmlId: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldDefectiveComponentReplacement = state.participantCopies[state.selectedParticipantCopyId]
        .functionalElements[props.id] as DefectiveComponentReplacement;

    if (oldDefectiveComponentReplacement.swapOutComponent.serialNo === props.newValue) {
        return state;
    }

    const newDefectiveComponentReplacement: { [key: string]: Readonly<DefectiveComponentReplacement> } = {};
    newDefectiveComponentReplacement[props.id] = {
        ...oldDefectiveComponentReplacement,
        swapOutComponent: {
            ...oldDefectiveComponentReplacement.swapOutComponent,
            serialNo: props.newValue,
        },
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDefectiveComponentReplacement,
    });
}

export function updateRepairTimeReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        xmlId: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldDefectiveComponentReplacement = state.participantCopies[state.selectedParticipantCopyId]
        .functionalElements[props.id] as DefectiveComponentReplacement;

    if (oldDefectiveComponentReplacement.repairTime === props.newValue) {
        return state;
    }

    const newDefectiveComponentReplacement: { [key: string]: Readonly<DefectiveComponentReplacement> } = {};
    newDefectiveComponentReplacement[props.id] = {
        ...oldDefectiveComponentReplacement,
        repairTime: props.newValue,
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDefectiveComponentReplacement,
    });
}

export const defectiveComponentReplacementReducer = [
    on<FormState, Array<typeof updateMaterialSwapIn>>(updateMaterialSwapIn, updateMaterialSwapInReducer),
    on<FormState, Array<typeof updateSerialSwapIn>>(updateSerialSwapIn, updateSerialSwapInReducer),
    on<FormState, Array<typeof updateMaterialSwapOut>>(updateMaterialSwapOut, updateMaterialSwapOutReducer),
    on<FormState, Array<typeof updateSerialSwapOut>>(updateSerialSwapOut, updateSerialSwapOutReducer),
    on<FormState, Array<typeof updateRepairTime>>(updateRepairTime, updateRepairTimeReducer),
];
